import React, { useEffect, useState } from "react";
import { Button, message } from "antd";
import { useNavigate } from "react-router-dom";
import "../styles/global-background.css";
import "../styles/InfoHub.css";
import Navbar from "../components/Navbar";
import { useAccount } from "wagmi";
import Footer from "../components/Footer";

interface PostItem {
  id: string;
  title: string;
  content: string;
  author: string;
  time: string;
  category: string;
}

// 工具函数：去除 markdown 语法，保留纯文本
function getPlainTextFromMarkdown(md: string, maxLength = 90): string {
  let text = md
    .replace(/!\[.*?\]\(.*?\)/g, '') // 图片
    .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1') // 链接
    .replace(/[`*_>#-]/g, '') // 行内代码、粗斜体、标题、列表符号
    .replace(/^\s*\d+\.\s+/gm, '') // 有序列表
    .replace(/^\s*[-*+]\s+/gm, '') // 无序列表
    .replace(/\\n/g, ' ') // 换行
    .replace(/\n+/g, ' ') // 多余换行
    .replace(/\s+/g, ' ') // 多余空格
    .trim();
  if (text.length > maxLength) {
    text = text.slice(0, maxLength) + '...';
  }
  return text;
}

const InfoHub: React.FC = () => {
  const { address } = useAccount();
  const [language, setLanguage] = useState<'en' | 'zh'>('zh');
  const navigate = useNavigate();

  const [posts, setPosts] = useState<PostItem[]>([]);

   useEffect(() => {
    fetch("/postsIndex.json")
      .then(res => res.json())
      .then(data => setPosts(data))
      .catch(err => console.error("文章索引加载失败", err));
  }, []);

  const handlePostClick = (postId: string) => {
    navigate(`/post/${postId}`);
  };

  // 按时间降序排序，首条大卡片
  const sortedPosts = [...posts].sort((a, b) => new Date(b.time).getTime() - new Date(a.time).getTime());
  const [firstPost, ...otherPosts] = sortedPosts;

  return (
    <div className="nova-container">
      <div className="nova-grid"></div>
      
      <Navbar language={language} />
      
      <div className="content">
        <div className="title-section">
          <h1 className="nova-title">{language === 'en' ? "News" : "新闻"}</h1>
          <p className="nova-subtitle">
            {language === 'en'
              ? "Latest news, guides, and community posts for all games"
              : "最新资讯、游戏攻略与社区内容"}
          </p>
        </div>

        <div className="news-list">
          {firstPost && (
            <div className="post-card featured-post" onClick={() => handlePostClick(firstPost.id)}>
              <h2 className="post-title">{firstPost.title}</h2>
              <p className="post-description">{getPlainTextFromMarkdown(firstPost.content)}</p>
              <div className="post-footer">
                <span className="post-time">{firstPost.time}</span>
                <Button
                  className="post-button"
                  onClick={e => { e.stopPropagation(); handlePostClick(firstPost.id); }}
                >
                  {language === 'en' ? "Read More" : "阅读更多"}
                </Button>
              </div>
            </div>
          )}
          <div className="posts-grid">
            {otherPosts.map((post, idx) => (
              <div className="post-card" key={post.id} onClick={() => handlePostClick(post.id)}>
                <h3 className="post-title">{post.title}</h3>
                <p className="post-description">{getPlainTextFromMarkdown(post.content)}</p>
                <div className="post-footer">
                  <span className="post-time">{post.time}</span>
                  <Button
                    className="post-button"
                    onClick={e => { e.stopPropagation(); handlePostClick(post.id); }}
                  >
                    {language === 'en' ? "Read More" : "阅读更多"}
                  </Button>
                </div>
              </div>
            ))}
          </div>
        </div>

        <Footer language={language} setLanguage={setLanguage} />
      </div>
    </div>
  );
};

export default InfoHub;